import { Component, OnInit, Input } from '@angular/core'
import { AuthenticationService } from '../../_services/authentication.service'
import { RequestsService } from '../../_shared/services/requests.service'
import { HelperFunctions } from '../../_shared/utils/helper-functions'
import * as moment from 'moment'

declare var jQuery: any

@Component({
  selector: 'app-inquiries',
  templateUrl: './inquiries.component.html',
  styleUrls: ['./inquiries.component.scss'],
})
export class InquiriesComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private helperFunction: HelperFunctions
  ) {}

  @Input() indiaStates
  @Input() ugandaDistricts

  isLoadingInquiries: boolean
  inquiriesData: any
  message: string
  countryName: string
  inqPage = 1
  count = 10
  model: any
  loading: boolean
  status: string
  isAddingInquiries: boolean
  inquiriesDataFilter: any
  searchItem: string
  isDeletingInquiry: boolean
  singleInquiriesViewData: any
  inquiryId: string
  isEditingInquiries: boolean
  isResolvingInquiry: boolean
  inqStates: any
  chosenState: string
  filterData: any
  chosenDistrict: string
  inqDistricts: any
  farmers: any
  filteredFarmers: any
  isLoadingFarmers: boolean
  selectedFarmer = {
    name: '',
    phone: '',
    district: '',
    state: '',
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
    this.model = {
      state: '',
    }
    this.loadInquiries()
    this.getAllFarmers()
  }

  loadInquiries(): void {
    this.isAddingInquiries ||
    this.isDeletingInquiry ||
    this.isEditingInquiries ||
    this.isResolvingInquiry
      ? (this.isLoadingInquiries = false)
      : (this.isLoadingInquiries = true)
    this.requestService.dash_get(`inquiry/${this.countryName}`, null).subscribe(
      (res) => {
        this.isLoadingInquiries = false
        this.inquiriesData = res.data
        this.filterData = res.data
        this.inquiriesDataFilter = res.data
        let inqStates = ['All states']
        let inqDistricts = ['All districts']

        this.inquiriesData.map((each) => {
          each.state ? inqStates.push(each.state) : null
          this.inqStates = Array.from(new Set(inqStates))

          each.district ? inqDistricts.push(each.district) : null
          this.inqDistricts = Array.from(new Set(inqDistricts))
        })

        !this.chosenState
          ? this.inqStates
            ? (this.chosenState = this.inqStates[0])
            : null
          : null
      },
      (err) => {
        this.isLoadingInquiries = false
        this.message = err.error
      }
    )
  }

  onInqStateOptionSelected(event: any) {
    this.chosenState = event.target.value
    let inqData = []

    if (this.chosenState === 'All states') {
      inqData = this.inquiriesData
    } else {
      this.inquiriesData
        ? this.inquiriesData.map((each) => {
            this.chosenState === each.state ? inqData.push(each) : null
          })
        : null
    }
    this.filterData = inqData
    this.inquiriesDataFilter = inqData
  }

  onDistrictOptionSelected(event: any) {
    this.chosenDistrict = event.target.value
    let inqData = []

    if (this.chosenDistrict === 'All districts') {
      inqData = this.inquiriesData
    } else {
      this.inquiriesData
        ? this.inquiriesData.map((each) => {
            this.chosenDistrict === each.district ? inqData.push(each) : null
          })
        : null
    }
    this.filterData = inqData
    this.inquiriesDataFilter = inqData
  }

  addInquiries(addInquiriesForm) {
    const formData = new FormData()

    let farmer_name =
      typeof addInquiriesForm.farmer === 'string'
        ? addInquiriesForm.farmer
        : addInquiriesForm.farmer.name

    let inquiry_date: any = moment(
      new Date(addInquiriesForm.inquiry_date)
    ).format('YYYY-MM-DD')

    formData.append('farmer_name', farmer_name)
    formData.append('state', addInquiriesForm.state)
    formData.append('district', addInquiriesForm.district)
    formData.append('contact', addInquiriesForm.contact)
    formData.append('answer', addInquiriesForm.answer)
    formData.append('question', addInquiriesForm.question)
    formData.append('inquiry_date', inquiry_date)
    formData.append('handled_by', addInquiriesForm.handled_by)

    this.loading = true

    this.requestService
      .dash_post(`inquiry/${this.countryName}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAddingInquiries = true
            this.loadInquiries()
            this.helperFunction.displayAlert(this.message, this.status)
            this.closeModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunction.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunction.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunction.displayAlert(this.message, this.status)
        }
      )
  }

  closeModal() {
    jQuery(document).ready(() => {
      jQuery('#addInquiryModal').modal('hide')
      jQuery('#addInquiryForm')[0].reset()
      this.isAddingInquiries = false
      this.selectedFarmer = {
        name: '',
        phone: '',
        district: '',
        state: '',
      }
    })
  }

  filterInquiries(event) {
    this.searchItem = event.target.value
    this.inquiriesDataFilter
      ? (this.inquiriesDataFilter = this.filterData.filter(
          (data) =>
            data.farmer_name
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }

  setSingleInquiriesViewData(data: object) {
    this.singleInquiriesViewData = data
    this.inquiryId = this.singleInquiriesViewData.id
  }

  deleteInquiry(id: string): void {
    this.loading = true
    this.requestService.dash_delete(id, `inquiry/update`).subscribe(
      (res) => {
        this.loading = false
        if (res.success === true) {
          this.status = 'success'
          this.isDeletingInquiry = true
          this.loadInquiries()
          this.message = res.message
          this.helperFunction.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingInquiry = false
            jQuery('#deleteInquiryModal').modal('hide')
          })
        } else if ((res.success = false)) {
          this.status = 'error'
          this.message = res.message
          this.helperFunction.displayAlert(this.message, this.status)
        }
      },
      (err) => {
        this.loading = false
        if (err.status === 404) {
          this.message = 'Inquiry not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunction.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingInquiry = false
            jQuery('#deleteInquiryModal').modal('hide')
          })
        }
      }
    )
  }

  editInquiries(editInquiriesForm) {
    const formData = new FormData()

    let inquiry_date: any = moment(
      new Date(editInquiriesForm.inquiry_date)
    ).format('YYYY-MM-DD')

    formData.append('farmer_name', editInquiriesForm.farmer_name)
    formData.append('state', editInquiriesForm.state)
    formData.append('district', editInquiriesForm.district)
    formData.append('contact', editInquiriesForm.contact)
    formData.append('answer', editInquiriesForm.answer)
    formData.append('question', editInquiriesForm.question)
    formData.append('inquiry_date', inquiry_date)
    formData.append('handled_by', editInquiriesForm.handled_by)

    this.loading = true

    this.requestService
      .dash_post(`inquiry/update/${this.inquiryId}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isEditingInquiries = true
            this.loadInquiries()
            this.helperFunction.displayAlert(this.message, this.status)
            this.closeEditModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunction.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunction.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunction.displayAlert(this.message, this.status)
        }
      )
  }

  closeEditModal() {
    jQuery(document).ready(() => {
      jQuery('#editInquiryModal').modal('hide')
      this.isEditingInquiries = false
    })
  }

  resolveInquiry(id: string) {
    this.loading = true
    this.requestService.dash_put(`inquiry/resolve/${id}`, null).subscribe(
      (res) => {
        this.loading = false
        if (res.success === true) {
          this.status = 'success'
          this.isResolvingInquiry = true
          this.loadInquiries()
          this.message = res.message
          this.helperFunction.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isResolvingInquiry = false
            jQuery('#resolveInquiryModal').modal('hide')
          })
        } else if ((res.success = false)) {
          this.status = 'error'
          this.message = res.message
          this.helperFunction.displayAlert(this.message, this.status)
        }
      },
      (err) => {
        this.loading = false
        if (err.status === 404) {
          this.message = 'Inquiry not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunction.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isResolvingInquiry = false
            jQuery('#resolveInquiryModal').modal('hide')
          })
        }
      }
    )
  }

  checkInquiryStatus(status: string, inquiry) {
    return status === inquiry.answered_status
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addInquiryModal').on('hidden.bs.modal', () => {
        this.closeModal()
      })
    })
  }

  getAllFarmers() {
    this.isLoadingFarmers = true
    this.requestService
      .dash_get(`contacts/farmers/${this.countryName}`, null)
      .subscribe(
        (res) => {
          this.isLoadingFarmers = false
          this.farmers = res.data
        },
        (err) => {
          this.message = err.error
          this.isLoadingFarmers = false
        }
      )
  }

  filterFarmers(event: any): void {
    if (this.farmers) {
      let farmers = this.farmers.map((each) => {
        each.name
          ? (each.name = this.helperFunction.titleCase(each.name.trim()))
          : null
        each.district
          ? (each.district = this.helperFunction.titleCase(
              each.district.trim()
            ))
          : null
        if (
          this.countryName === 'Uganda' &&
          each.phone &&
          each.phone.toString().trimStart().charAt(0) === '7'
        ) {
          each.phone = '0' + each.phone
        }
        return each
      })
      this.filteredFarmers = farmers.filter((each) =>
        each.name.startsWith(event.query)
      )
    }
  }

  handleSelectedFarmer(event: any): void {
    this.selectedFarmer.name = event.name
    event.phone !== 'NA' ? (this.selectedFarmer.phone = event.phone) : null
    event.district !== 'NA' && event.district !== ''
      ? ((this.selectedFarmer.district = event.district),
        (this.selectedFarmer.state = event.district))
      : null
  }
}
